export default "__VITE_ASSET__BrSCZycR__"